import React from 'react';
import {NestedMarkdown} from 'generic/MarkdownRendererV2/NestedMarkdown.react';
import {SupplementChip} from 'client/components/QuestionTypes/shared/DraggableChip';
import {extractSupplementParts} from './utils';

interface MarkdownWithSupplementProps {
  text: string;
  className?: string;
  isOptionEliminated?: boolean;
  nested?: boolean;
}

/**
 * Renders markdown text with supplement badge support.
 * If the text contains a supplement token, renders the plain text portion
 * via MarkdownRendererV2 alongside a small SupplementChip.
 * Otherwise, renders the full text as standard markdown.
 */
export function MarkdownWithSupplement({
  text,
  className,
  isOptionEliminated,
  nested
}: MarkdownWithSupplementProps) {
  const parts = extractSupplementParts(text);

  if (!parts) {
    return <NestedMarkdown text={text} className={className} />;
  }

  return (
    <div className={className}>
      {parts.text && <NestedMarkdown text={parts.text} />}
      <SupplementChip
        value={parts.supplementToken}
        size='small'
        isOptionEliminated={isOptionEliminated}
        nested={nested}
      />
    </div>
  );
}
